// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ty7j4LqW{height:40px !important;width:40px !important}`, "",{"version":3,"sources":["webpack://./src/fsd/widgets/header/ui/CheckButton/CheckButton.module.scss"],"names":[],"mappings":"AAAA,UACE,sBAAA,CACA,qBAAA","sourcesContent":[".checkButton {\n  height: 40px !important;\n  width: 40px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkButton": `Ty7j4LqW`
};
export default ___CSS_LOADER_EXPORT___;
